import React, { useEffect, useState, useRef } from "react";
import SwiperCore, { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import Grid from "@mui/material/Grid";
import language from "../../../../language";
import { useSelector } from "react-redux";
import store from "../../../../store";
import { getDepartureTrips, getReturnTrips } from "../../../../actions/trips";
import { UpdateReturnDate } from "../../../../actions/bookings";
SwiperCore.use([Navigation]);

const CalendarSlider = ({
    Date: propDate,
    miniPriceDeparture: miniPriceDeparture,
    setSelectedDepartureDate,
    setLoadReturnTrips,
    allTrips,
    route2,
    route1
}) => {
    let languageSelectedEnglish =
        sessionStorage.getItem("language") === "english" ||
            !sessionStorage.getItem("language")
            ? true
            : false;

    const formatDate = (dateStr) => {
        const dateObj = new Date(dateStr);
        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = String(dateObj.getFullYear());

        return `${year}-${month}-${day}`;
    };


    const swiperRef = useRef(null);
    const today = new Date();
    const [dates, setDates] = useState([]);
    const [isManualSelection, setIsManualSelection] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [hasSelectedDate, setHasSelectedDate] = useState(false);
    const requestData = useSelector((state) => state?.buses?.requesInfo);
    const [returnTripsdata, setReturnTripsdata] = useState({
        from: requestData?.to,
        to: requestData?.from,
        date: formatDate(requestData?.returnDate),
    });


    useEffect(() => {
        store.dispatch(UpdateReturnDate(selectedDate))
    }, [selectedDate])


    useEffect(() => {
        if (returnTripsdata.date) {
            store.dispatch(getReturnTrips(returnTripsdata));
        }
    }, [returnTripsdata]);


    const calculatePriceForDate = (date) => {
        const dayOfWeek = date.toLocaleString("en-US", { weekday: "long" }); // Get the day of the week (e.g., "Wednesday")

        // Filter trips based on route1 and route2
        const filteredTrips = allTrips?.filter(
            (trip) => trip?.routeFrom === route1 && trip?.routeTo === route2
        );

        // Find trips that have the current day in daysOfWeek
        const tripsWithDay = filteredTrips?.filter((trip) =>
            trip.daysOfWeek?.includes(dayOfWeek)
        );

        // Find the minimum price among those trips
        const minPriceTrip = tripsWithDay?.reduce(
            (minTrip, currentTrip) => {
                return currentTrip?.price < minTrip.price ? currentTrip : minTrip;
            },
            { price: Infinity }
        );

        // Return the minimum price or a default message if no trips are found
        return minPriceTrip?.price !== Infinity ? minPriceTrip?.price : null;
    };



    const stripTime = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const getScreenOffset = () =>
        window.screen.width >= 1400
            ? 3
            : window.screen.width >= 1280
                ? 2
                : window.screen.width >= 768
                    ? 1
                    : 1;

    const parsePropDate = (value) => {
        if (!value) return null;
        if (value instanceof Date) return value;

        if (typeof value === "string") {
            const m = value
                .trim()
                .match(/^(\d{1,2})\s+([A-Za-z]{3})\s+(\d{2}|\d{4})$/);
            if (m) {
                const d = parseInt(m[1], 10);
                const monStr = m[2];
                const yStr = m[3];
                const months = [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec",
                ];
                const mon = months.indexOf(monStr);
                const y =
                    yStr.length === 2 ? 2000 + parseInt(yStr, 10) : parseInt(yStr, 10);
                return new Date(y, mon, d);
            }
        }
        const dt = new Date(value);
        return isNaN(dt) ? null : dt;
    };

    const generateDatesRange = (startIndex = 0, numberOfDaysToAdd = 30) => {
        const offset = getScreenOffset();
        const base = stripTime(new Date());
        return Array.from({ length: numberOfDaysToAdd }, (_, idx) => {
            const adjustedIndex = startIndex + idx;
            const currentDate = new Date(base);
            currentDate.setDate(base.getDate() + adjustedIndex - offset);

            const dayOfWeek = currentDate.toLocaleString("en-US", {
                weekday: "short",
            });
            const dayOfMonth = currentDate.getDate();
            const month = currentDate.toLocaleString("default", { month: "short" });

            const dateClassName =
                currentDate < base
                    ? "calendar-block disabled-date"
                    : "calendar-block colored-dates";

            const price = calculatePriceForDate(currentDate);

            return {
                key: `${dayOfMonth}-${month}-${adjustedIndex}`,
                date: `${dayOfWeek} ${dayOfMonth} ${month}`,
                selected: false,
                className: dateClassName,
                price,
                fullDate: currentDate,
            };
        });
    };





    const addMoreDates = (startIndex = 0, numberOfDaysToAdd = 14) => {
        const newDates = generateDatesRange(startIndex, numberOfDaysToAdd);
        setDates((prevDates) => [...prevDates, ...newDates]);
    };

    // Initial load of dates
    useEffect(() => {
        if (!dates.length) setDates(generateDatesRange(0, 30));
    }, []);

    const handleSlideChange = (swiper) => {
        const totalSlides = dates.length;
        const loadMoreTriggerIndex = totalSlides - 10; // Start adding more dates when reaching the last 10 slides

        if (swiper.activeIndex >= loadMoreTriggerIndex) {
            addMoreDates(dates.length, 14); // Add 14 more dates when reaching the threshold
        }
    };

    const formatSelectedDate = (dateObj) => {
        const year = dateObj.getFullYear();
        const month = dateObj.getMonth() + 1;
        const day = dateObj.getDate();

        return `${year}/${month < 10 ? "0" : ""}${month}/${day < 10 ? "0" : ""}${day}`;
    };

    useEffect(() => {
        const target = parsePropDate(propDate);
        if (!target || isManualSelection || hasSelectedDate) return;

        const base = stripTime(new Date());
        const offset = getScreenOffset();
        const daysDiff = Math.round((stripTime(target) - base) / 86400000);
        const targetIndex = daysDiff + offset;
        if (targetIndex < 0) return;

        const start = Math.max(0, targetIndex - 15);
        const block = generateDatesRange(start, 30);
        const idx = targetIndex - start;

        block[idx].selected = true;
        setDates(block);

        const formattedDate = formatSelectedDate(block[idx].fullDate);
        setSelectedDate(formattedDate);
        setHasSelectedDate(true);
        setSelectedDepartureDate(formattedDate);

        if (swiperRef.current && swiperRef.current.params?.slidesPerView) {
            swiperRef.current.slideTo(
                Math.max(
                    0,
                    idx - Math.floor(swiperRef.current.params.slidesPerView / 2)
                ),
                300
            );
        }
    }, [propDate, isManualSelection, dates, hasSelectedDate]);

    const handleDateClick = async (clickedDate) => {
        setIsManualSelection(true); // Set manual selection to true
        const tempDates = [...dates];
        const clickedIndex = tempDates.findIndex(
            (date) => date.date === clickedDate
        );

        if (
            clickedIndex !== -1 &&
            tempDates[clickedIndex].className !== "calendar-block disabled-date"
        ) {
            tempDates.forEach((date) => (date.selected = false));
            tempDates[clickedIndex].selected = true;
            setDates(tempDates);

            const formattedDate = formatSelectedDate(tempDates[clickedIndex].fullDate);
            setSelectedDate(formattedDate);
            const formattedDate1 = formattedDate.replace(/\//g, '-');

            setLoadReturnTrips(true)
            setReturnTripsdata((prevData) => {
                const updatedData = {
                    ...prevData,
                    date: formattedDate1,
                };
                store.dispatch(getReturnTrips(updatedData)); // Dispatch with updated data
                return updatedData;
            });

            // Update parent state
            await setSelectedDepartureDate(formattedDate1); // Set selected departure date in parent state
            if (swiperRef.current && swiperRef.current.params?.slidesPerView) {
                swiperRef.current.slideTo(
                    clickedIndex - Math.floor(swiperRef.current.params.slidesPerView / 2),
                    300
                );
            }
        }
    };


    return (
        <Grid item xs={12} align="center" className="border-wrap">
            <p className="date-selection-title">
                {languageSelectedEnglish ? "Select A Date" : language.selectADate}
            </p>
            <Swiper
                spaceBetween={10}
                className="sliderTripsOuter"
                navigation
                watchSlidesProgress
                onSlideChange={handleSlideChange}
                breakpoints={{
                    1900: {
                        slidesPerView: 7,
                    },
                    1420: {
                        slidesPerView: 5,
                    },
                    1280: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 3,
                    },
                    0: {
                        slidesPerView: 3,
                    },
                }}
                onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                }}
            >
                {dates?.map((date) => {
                    let tempDateSplit = date.date.split(" ");
                    let todayDate =
                        parseInt(today.toDateString().split(" ")[2]) ===
                        parseInt(date.date.split(" ")[1]);

                    return (
                        <SwiperSlide key={date.key}>
                            <div
                                className={
                                    date.selected
                                        ? "calendar-block selected-date"
                                        : date.className
                                }
                                onClick={() => handleDateClick(date.date)}
                                style={{
                                    border: `${todayDate ? "2px solid #007aff" : ""}`,
                                }}
                            >
                                <div className="day-of-week">{tempDateSplit[0]}</div>
                                <div className="day-of-month">
                                    {tempDateSplit[1]} {tempDateSplit[2]}
                                </div>
                                <div className="month">
                                    {"From"} SAR {date?.price !== null ? date?.price : "N/A"}
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </Grid>
    );
};

export default CalendarSlider;
